import { Link } from 'react-router-dom';
import { NEW_DESIGN_PROJECTS_PATH, rememberDesign } from '@/lib/designChoice';
import { NewDesignScope } from './NewDesignScope';
import { Button } from './ui/button';

/**
 * «Новый интерфейс» в шапке старого (концепт design-switch 2.2): кнопка из нового дизайна — лаймовая, Inter, — кусочек того,
 * куда ведёт. Запоминает выбор: «/», вход и «Проекты» в меню дальше открывают новый дизайн.
 */
export function ToNewDesignButton() {
  return (
    <NewDesignScope>
      <Button asChild>
        <Link to={NEW_DESIGN_PROJECTS_PATH} onClick={() => rememberDesign('new')}>
          Новый интерфейс
        </Link>
      </Button>
    </NewDesignScope>
  );
}
